FiltersMdl.controller( 'ColorFansCtrl', [ '$scope', '$state', '$timeout', '$element', 'color_fans', 'color_fan', 'HuesSrv', 'HuesUpdaterSrv',
	function ( $scope, $state, $timeout, $element, color_fans, color_fan, HuesSrv, HuesUpdaterSrv ) {

	this.color_fans = color_fans;

	////If there is no specific selected fan, pass all fans.
	HuesSrv.setFilter('color_fan', color_fan ? color_fan : color_fans );


	//HuesSrv.setFilter('hue', false );
	HuesUpdaterSrv.isSearch = false;
	HuesSrv.setFilter('search_term', false );
	HuesSrv.setFilter('search_single', false );

}]);
